/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { styled, Typography } from '@mui/material';

interface LegendItem {
  label: string;
  iconColor: string;
}

const LegendLabel = styled(Typography)``;
const LegendSquare = styled('div')<Pick<LegendItem, 'iconColor'>>`
  width: 13px;
  height: 13px;
  border-radius: 4px;
  background: ${({ iconColor }) => iconColor};
`;

const LegendView = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 16px;
  row-gap: 0;
  flex-wrap: wrap;
`;

const LegendItemWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;

interface Props {
  values: LegendItem[];
}

export const Legend = (props: Props) => {
  return (
    <LegendView>
      {props.values.map((value) => (
        <LegendItemWrapper key={value.label}>
          <LegendSquare iconColor={value.iconColor} />
          <LegendLabel variant='body2'>{value.label}</LegendLabel>
        </LegendItemWrapper>
      ))}
    </LegendView>
  );
};

export default Legend;
